<script>
	export default {
		name: 'LocalStorageExecuter',
		methods: {
			checkLocalStorageVersion() {
				const self_ = this;
				
				const version_ = self_.getLocalStorage('version')

				if(self_.isFalse(version_)) { return false }

				const deployed_ = self_.getDeployedVersion()
				const deployedLocal_ = self_.getDeployedVersionLocal()

				if(deployed_ != deployedLocal_) { return false }
				else { return true }
			},
			initializeLocalStorage(storageName) {
				const self_ = this;

				const name_ = self_.convertCaseToPascal(storageName)

				let state_ = {}
				
				if(storageName == 'langs') { state_ = self_.getLangsState() }
				if(storageName == 'styles') { state_ = self_.getStylesState() }

				Promise.resolve().then(() => {
					return self_.getFirestoreCollection(storageName, {}, 0)
				}).then(result => {
					Object.keys(result).forEach(key => {
						state_[key] = result[key]
					})

					self_.setLocalStorage(name_, state_)
				}).catch(error => {
/* error */			self_.logError('Error', 'initializeLocalStorage(' + storageName + ')', error)
				})
			},
			getLocalStorage(storageName) {
				const self_ = this;
				const storage_ = self_.$storage;
				
				const name_ = self_.convertCaseToPascal(storageName)
				return storage_.get(name_)
			},
			setLocalStorage(storageName, value) {
				const self_ = this;
				const storage_ = self_.$storage;
				
				const name_ = self_.convertCaseToPascal(storageName)
				return storage_.set(name_, value)
			},
			removeLocalStorage(storageName) {
				const self_ = this;
				const storage_ = self_.$storage;
				
				const name_ = self_.convertCaseToPascal(storageName)
				return storage_.remove(name_)
			}
		}
	}
</script>